/**
 * Initial state factory for the "alerts" (notifications) Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. Keeps unread and read
 * notifications as separate lists (each with its own count), plus an
 * `isLoaded` flag and per-fetch error messages for the notifications list
 * and the unread count. Note: `notifications` (an aggregate list some
 * mutations below read/write) is commented out here, so it starts out
 * `undefined` rather than `[]`.
 */
export default () => ({
  //notifications: [],
  unreadNotifications: [],
  readNotifications: [],
  count: 0,
  isLoaded: false,  
  unreadNotificationsCount: 0,
  readNotificationsCount: 0,
  notificationsError: null,
  unreadCountError: null,
  // Background refreshes should not block the UI today.
  // notificationsLoading: false,
  // unreadCountLoading: false,
});
